import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private isGenericFlow: boolean = false;

  constructor(private router: Router) {
    // Initialize flow on service creation
    this.initializeFlow();
  }

  /**
   * Initialize the flow based on environment and domain
   * This method is called on service creation and can be called on page reload
   */
  initializeFlow(): void {
    this.isGenericFlow = this.determineFlow();

    // Store in localStorage for persistence across page reloads
    localStorage.setItem('isGenericFlow', this.isGenericFlow.toString());

    // console.log('Flow initialized:', this.isGenericFlow ? 'Generic' : 'Education');
  }

  /**
   * Determine the flow based on environment configuration and domain
   */
  private determineFlow(): boolean {
    // If debug is false (local development), use environment.isGenericFlow directly
    if (environment.debug) {
      return environment.isGenericFlow;
    } else {
      // If debug is true (production), check the current domain
      if (window.location.href.includes("brand-score-ai-app-yetrh.ondigitalocean.app")) {
        return false; // Education Flow
      } else {
        return true; // Generic Flow
      }
      // if (window.location.href.includes("generic-brand-score-ai.angularwebtechnology.com")) {
      //   return true; // Generic Flow
      // } else {
      //   return false; // Education Flow
      // }
    }
  }

  /**
   * Get current flow state
   */
  getCurrentFlow(): boolean {
    return this.isGenericFlow;
  }

  /**
   * Check if current flow is generic
   */
  isGenericFlowActive(): boolean {
    return this.isGenericFlow;
  }

  /**
   * Check if current flow is education
   */
  isEducationFlowActive(): boolean {
    return !this.isGenericFlow;
  }

  /**
   * Navigate to the appropriate landing page based on current flow
   */
  navigateToLandingPage(): void {
    if (this.isGenericFlow) {
      this.router.navigate(['/generic-home']);
    } else {
      this.router.navigate(['/education-home']);
    }
  }

  /**
   * Force refresh flow determination (useful after login or when environment changes)
   */
  refreshFlow(): void {
    this.initializeFlow();
  }

  /**
   * Get flow from localStorage (for persistence across page reloads)
   */
  getFlowFromStorage(): boolean | null {
    const stored = localStorage.getItem('isGenericFlow');
    return stored ? stored === 'true' : null;
  }
}
